import { asyncHandler } from '../async-handler';
import store from '../../../store/store';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import {
  ADUP_API_KEYS_API,
  ADUP_API_KEY_GENERATE_API,
  ADUP_API_KEY_DELETE_API,
} from '../../constants/central-api';
import { applicationWWWXRLEncodedBodyBuilder } from '../../utils/body-builder';

export interface AdUpApiKey {
  id: number;
  name: string;
  type: string;
  api_key: string;
  api_secret: string;
  configs: any;
  accepted_hosts: any;
  additional_configs: any;
  is_active: number;
  integrable_type: string;
  integrable_id: string;
  created_at: string;
  updated_at: string;
  slug: any;
  deleted_at: any;
  category: any;
  is_encrypted: number;
  user_id: string;
  read_scope: number;
  write_scope: number;
}

export interface AdUpApiKeyResponse {
  success: boolean;
  message: string | null;
  data: AdUpApiKey[] | null;
}

export interface CreateAdUpApiKeyRequest {
  name: string;
  read_scope: number;
  write_scope: number;
}

export interface CreateAdUpApiKeyResponse {
  success: boolean;
  message: string;
  data: null;
}

export interface DeleteAdUpApiKeyResponse {
  success: boolean;
  message: string;
  data: null;
}

export default async function get_adup_api_keys_api_call(): Promise<
  AdUpApiKey[] | null
> {
  const shopId = store.getState().user?.company?.shop_id;
  const accessToken = store.getState().auth.authorization.accessToken;
  const sellerToken = accessToken?.sellerToken;

  const requestInfo: RequestInfo = {
    url: ADUP_API_KEYS_API(shopId),
    method: 'GET',
    headers: {
      Accept: 'application/json',
      Authorization: accessToken.type + ' ' + sellerToken,
    },
  };

  const actionType = 'GET_ADUP_API_KEYS';
  const customMsg = 'AdUp API Keys Fetched Successfully.';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false
  );

  const response: AdUpApiKeyResponse = res?.data;
  if (!response?.success) {
    return null;
  }

  if (res.actionType === actionType && response.success === true) {
    return response.data || [];
  }

  return null;
}

export async function create_adup_api_key_api_call(
  keyData: CreateAdUpApiKeyRequest
): Promise<boolean> {
  const shopId = store.getState().user?.company?.shop_id;
  const accessToken = store.getState().auth.authorization.accessToken;
  const sellerToken = accessToken?.sellerToken;

  const requestInfo: RequestInfo = {
    url: ADUP_API_KEY_GENERATE_API(shopId),
    method: 'POST',
    body: applicationWWWXRLEncodedBodyBuilder(keyData),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: accessToken.type + ' ' + sellerToken,
    },
  };

  const actionType = 'CREATE_ADUP_API_KEY';
  const customMsg = 'AdUp API Key Created Successfully.';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    true,
    false
  );

  const response: CreateAdUpApiKeyResponse = res?.data;
  if (!response?.success) {
    return false;
  }

  if (res.actionType === actionType && response.success === true) {
    return true;
  }

  return false;
}

export async function delete_adup_api_key_api_call(
  apiKeyId: string
): Promise<boolean> {
  const accessToken = store.getState().auth.authorization.accessToken;
  const sellerToken = accessToken?.sellerToken;

  const requestInfo: RequestInfo = {
    url: ADUP_API_KEY_DELETE_API(apiKeyId),
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      Authorization: accessToken.type + ' ' + sellerToken,
    },
  };

  const actionType = 'DELETE_ADUP_API_KEY';
  const customMsg = 'AdUp API Key Deleted Successfully.';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    true,
    false
  );

  const response: DeleteAdUpApiKeyResponse = res?.data;
  if (!response?.success) {
    return false;
  }

  if (res.actionType === actionType && response.success === true) {
    return true;
  }

  return false;
}
